var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7489 18.7723H22.916C22.226 18.7723 21.666 18.2205 21.666 17.5405C21.666 16.8606 22.226 16.3087 22.916 16.3087H38.7489C39.4389 16.3087 39.9989 16.8606 39.9989 17.5405C39.9989 18.2205 39.4389 18.7723 38.7489 18.7723Z",
    fill: "#FF0742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4989 24.9314C32.1788 24.9314 31.859 24.8114 31.6155 24.5702C31.1272 24.0888 31.1272 23.3087 31.6155 22.8275L36.9821 17.539L31.6155 12.2503C31.1272 11.7691 31.1272 10.989 31.6155 10.5078C32.104 10.0264 32.8956 10.0264 33.3839 10.5078L39.6337 16.6669C40.122 17.1481 40.122 17.9282 39.6337 18.4094L33.3839 24.5684C33.1389 24.8114 32.819 24.9314 32.4989 24.9314Z",
    fill: "#FF0742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 39.7132C12.9763 39.7132 12.6378 39.6638 12.2997 39.5604L2.26983 36.2673C0.905123 35.7976 0 34.5444 0 33.1436V3.5801C0 1.76847 1.49501 0.295166 3.33333 0.295166C3.68976 0.295166 4.02819 0.344487 4.36662 0.44794L14.3962 3.74099C15.7612 4.21074 16.666 5.4639 16.666 6.86473V36.4282C16.666 38.2399 15.1713 39.7132 13.333 39.7132ZM3.33333 2.75879C2.87497 2.75879 2.49992 3.12839 2.49992 3.5801V33.1436C2.49992 33.4933 2.73826 33.8184 3.07821 33.9351L13.0611 37.2134C13.1328 37.2363 13.2262 37.2495 13.333 37.2495C13.7914 37.2495 14.1661 36.8799 14.1661 36.4282V6.86473C14.1661 6.51498 13.9278 6.18988 13.5878 6.07319L3.60493 2.79488C3.53321 2.77202 3.43983 2.75879 3.33333 2.75879Z",
    fill: "#FF0742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4157 13.4346C24.7257 13.4346 24.1657 12.8827 24.1657 12.2028V4.81191C24.1657 3.68024 23.231 2.75879 22.0826 2.75879H3.33323C2.64325 2.75879 2.08327 2.20694 2.08327 1.52698C2.08327 0.847016 2.64325 0.295166 3.33323 0.295166H22.0826C24.6109 0.295166 26.6656 2.32032 26.6656 4.81191V12.2028C26.6656 12.8827 26.1056 13.4346 25.4157 13.4346Z",
    fill: "#FF0742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0827 34.7859H15.416C14.7261 34.7859 14.1661 34.2341 14.1661 33.5541C14.1661 32.8741 14.7261 32.3223 15.416 32.3223H22.0827C23.231 32.3223 24.1658 31.4008 24.1658 30.2692V22.8783C24.1658 22.1983 24.7257 21.6465 25.4157 21.6465C26.1057 21.6465 26.6657 22.1983 26.6657 22.8783V30.2692C26.6657 32.7607 24.611 34.7859 22.0827 34.7859Z",
    fill: "#FF0742"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 39.4192,
    fill: "white",
    transform: "translate(0 0.293945)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8121bc74c4cb99e9b8cabd43bae07189.svg";
export { ForwardRef as ReactComponent };